import React from 'react';
import { useTranslation } from 'react-i18next';
import type { MediaAssetResponse } from 'we-tree-api-client/v2';
import OverviewPhotoThumb from './OverviewPhotoThumb';

interface OverviewLatestPhotosCardProps {
  familyId: string;
  photos: MediaAssetResponse[];
  totalCount: number | null;
  isLoading: boolean;
  onViewAll: () => void;
  onPhotoClick: () => void;
}

const OverviewLatestPhotosCard: React.FC<OverviewLatestPhotosCardProps> = ({
  familyId,
  photos,
  totalCount,
  isLoading,
  onViewAll,
  onPhotoClick
}) => {
  const { t } = useTranslation('overview');

  return (
    <section className="overview-card" aria-labelledby="overview-latest-photos-title">
      <header className="overview-card__head">
        <h2 id="overview-latest-photos-title" className="overview-card__title">
          {t('photos.title')}
          {totalCount !== null && totalCount > 0 && (
            <span className="overview-card__count">{totalCount.toLocaleString()}</span>
          )}
        </h2>
        <button type="button" className="overview-card__more" onClick={onViewAll}>
          {t('photos.viewAll')}
        </button>
      </header>
      {isLoading ? (
        <p className="overview-card__empty">{t('photos.loading')}</p>
      ) : photos.length === 0 ? (
        <p className="overview-card__empty">{t('photos.empty')}</p>
      ) : (
        <div className="overview-photos-grid">
          {photos.map((asset) => (
            <OverviewPhotoThumb key={asset.id} familyId={familyId} asset={asset} onClick={onPhotoClick} />
          ))}
        </div>
      )}
    </section>
  );
};

export default OverviewLatestPhotosCard;
